import { useState, useEffect } from 'react';

export const useOtpPushListener = () => {
  const [receivedCode, setReceivedCode] = useState(null);

  useEffect(() => {
    // 🔔 Memunculkan notifikasi sistem di HP saat web SEDANG DIBUKA (Foreground)
    const showSystemNotificationInForeground = (title, body, otp) => {
      if (typeof window === 'undefined' || !('Notification' in window)) return;
      if (Notification.permission !== 'granted') return;

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.showNotification(title || "Kode OTP Verifikasi", {
            body: body || (otp ? `🔑 Kode OTP Anda: ${otp}` : "Kode OTP Anda telah tiba."),
            icon: "./logo.png",
            badge: "./logo.png",
            tag: "otp-notification", // 🔑 Tag yang sama -> Anti-dobel!
            renotify: true,          // Bergetar & bersuara
            requireInteraction: true,
            vibrate: [200, 100, 200],
            data: {
              otp: otp,
              click_action: window.location.pathname
            }
          }).catch((err) => {
            console.warn("[useOtpPushListener] Gagal memunculkan notifikasi foreground:", err);
          });
        });
      }
    };

    const handleIncomingData = (data) => {
      if (!data) return;
      console.log("[useOtpPushListener] Data push diterima di web:", data);

      let otp = data.otp;
      let title = data.title || data.notification?.title || "Kode OTP Verifikasi";
      let body = data.body || data.notification?.body || "";

      if (!otp) {
        const textSearch = typeof data === 'string' ? data : (body || title || JSON.stringify(data));
        const match = textSearch.match(/\b\d{6}\b/);
        if (match) {
          otp = match[0];
        }
      }

      if (otp) {
        setReceivedCode(otp);
      }

      // Munculkan banner notifikasi di HP
      showSystemNotificationInForeground(title, body, otp);
    };

    // 1. Dengar via BroadcastChannel
    let channel = null;
    if (typeof BroadcastChannel !== 'undefined') {
      try {
        channel = new BroadcastChannel('otp_channel');
        channel.onmessage = (event) => {
          if (event.data) {
            handleIncomingData(event.data);
          }
        };
      } catch (err) { }
    }

    // 2. Dengar via Service Worker postMessage
    const handleServiceWorkerMessage = (event) => {
      if (event.data) {
        handleIncomingData(event.data);
      }
    };

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
    }

    return () => {
      if (channel) channel.close();
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
      }
    };
  }, []);

  return { receivedCode };
};

export default useOtpPushListener;